import { render } from "./customer-segment-actions.vue?vue&type=template&id=5e3cf0d9&scoped=true"
import script from "./customer-segment-actions.vue?vue&type=script&lang=js"
export * from "./customer-segment-actions.vue?vue&type=script&lang=js"

import "./customer-segment-actions.vue?vue&type=style&index=0&id=5e3cf0d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3cf0d9"]])

export default __exports__